<template>
    <div :id="id" class="selection-indicator" v-if="Show()" :style="`width: ${width}; left: ${left};`"></div>
</template>

<script>
import $ from "jquery";
import { Animation } from "@/assets/JS/Animation.js";

export default {
    name: "PrioritySelectionIndicator",
    props: {
        id: String,
        priorityType: Object,
        width: String,
        left: String,
        selected: String,
        noUpdate: Boolean
    },
    methods: {
        Show: function() {
            if (this.priorityType) {
                return this.priorityType.PriorityType === this.selected;
            }
            return false;
        }
    },
    updated: function() {
        if (!this.noUpdate) {
            if (this.Show()) {
                const $indicator = $(`#${this.id}`);
                $indicator.css("opacity", 1);
                new Animation($indicator, "Fade", 0, 1000, 0);
            }
        }
    }
};
</script>